import { Survey } from 'api/general/models';
import { actionsFactories } from '../utils';
import { EntityType } from '../types';
import { GetSurveyByEmailParamsType, UpdateSurveyByEmailParamsType } from './types';

export const getSurveyByEmail = actionsFactories.createGetOneActionsFactory<
  EntityType<Survey>,
  GetSurveyByEmailParamsType
>()(
  'GET_SURVEY_BY_EMAIL_REQUEST',
  'GET_SURVEY_BY_EMAIL_SUCCESS',
  'GET_SURVEY_BY_EMAIL_FAILURE',
  'RESET_SURVEY_BY_EMAIL',
);

export const updateSurveyByEmail = actionsFactories.createUpdateOneActionsFactory<
  EntityType<Survey>,
  UpdateSurveyByEmailParamsType
>()(
  'UPDATE_SURVEY_BY_EMAIL_REQUEST',
  'UPDATE_SURVEY_BY_EMAIL_SUCCESS',
  'UPDATE_SURVEY_BY_EMAIL_FAILURE',
  'UPDATE_SURVEY_BY_EMAIL_RESET',
);

export const getSurveys = actionsFactories.createGetManyActionsFactory<EntityType<Survey>>()(
  'GET_SURVEYS_REQUEST',
  'GET_SURVEYS_SUCCESS',
  'GET_SURVEYS_FAILURE',
  'RESET_SURVEYS',
);

export const updateSurvey = actionsFactories.createUpdateOneActionsFactory<EntityType<Survey>>()(
  'UPDATE_SURVEY_REQUEST',
  'UPDATE_SURVEY_SUCCESS',
  'UPDATE_SURVEY_FAILURE',
  'UPDATE_SURVEY_RESET',
);
